import { render, staticRenderFns } from "./ViaInvest.vue?vue&type=template&id=40660d3b"
import script from "./ViaInvest.vue?vue&type=script&lang=js"
export * from "./ViaInvest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports